<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'TemplateManagement',
})
</script>
<template>
    <a-card :bordered="false">
        <div class="table-page-search-wrapper">
            <a-form>
                <a-row :gutter="48">
                    <a-col :md="3" :sm="24">
                        <a-form-item label="区域">
                            <a-input @keyup.enter="loadData" v-model:value="queryParam.quyu" placeholder="区域"></a-input>
                        </a-form-item>
                    </a-col>
                    <a-col :md="6" :sm="24">
                        <a-form-item label="公司名称">
                            <a-input @keyup.enter="loadData" v-model:value="queryParam.companyname"
                                placeholder="请输入公司名称"></a-input>
                        </a-form-item>
                    </a-col>
                    <a-col :md="5" :sm="24">
                        <a-form-item label="电话搜索">
                            <a-input @keyup.enter="loadData" v-model:value="queryParam.tel"
                                placeholder="电话搜索"></a-input>
                        </a-form-item>
                    </a-col>
                    <a-col :md="6" :sm="24">
                        <a-form-item label="住所">
                            <a-input @keyup.enter="loadData" v-model:value="queryParam.addr" placeholder="住所"></a-input>
                        </a-form-item>
                    </a-col>
                    <a-col :md="4" :sm="24">
                        <span class="table-page-search-submitButtons">
                            <a-button type="primary" @click="loadData">查询</a-button>
                            <a-button style="margin-left: 8px" @click="refreshTabel">重置</a-button>
                        </span>
                    </a-col>
                </a-row>
            </a-form>
        </div>
        <div class="table-operator">
            <a-button type="primary" :icon="h(PlusOutlined)" @click="handleAdd">新建电话</a-button>
        </div>
        <a-table :columns="columns" :loading="state.loading" :data-source="dataSource" :pagination="pagination"
            @change="onChange">
            <template #bodyCell="{ column, record, index, text }">
                <template v-if="column.dataIndex === 'companyname'">
                    <div>{{ text }}</div>
                    <div v-if="record.companyname2">历史名称：{{ record.companyname2 }}</div>
                    <div v-if="record.addr">住所：{{ record.addr }}</div>
                </template>
                <template v-if="column.dataIndex === 'mail'">
                    <div>{{ text }}</div>
                    <div v-if="record.mail2 && record.mail2 != '-'">{{ record.mail2 }}</div>
                    <div v-if="record.website && record.website != '-'">网址：{{ record.website }}</div>
                </template>
                <template v-if="column.dataIndex === 'regtime'">
                    <div>{{ new Date(record.regtime * 1000).toLocaleDateString() }}</div>
                </template>
                <template v-if="column.dataIndex === 'tel'">
                    <a @click="onUsbphoneClick(record, text)">{{ text }}
                        <PhoneOutlined />
                    </a>
                    <div v-if="record.tel2 && record.tel2 != '-'">更多：{{ record.tel2 }}</div>
                </template>
                <!-- <template v-if="column.dataIndex === 'operate'">
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a-popconfirm title="确定删除此模板?" @confirm="handleDelete(record)">
            <a style="color: red">删除</a>
          </a-popconfirm>
        </template> -->
            </template>
        </a-table>
        <createPeer v-if="state.showCreate" :detailData="state.detailData" @cancel="
            () => {
                loadData()
                state.showCreate = false
            }
        "></createPeer>
    </a-card>
</template>

<script lang="ts" setup name="TemplateManagement">
import { PlusOutlined, PhoneOutlined } from '@ant-design/icons-vue'
import type { PaginationProps } from 'ant-design-vue'
import { message } from 'ant-design-vue'
import baseService from '@/utils/http/axios'
import { ref, reactive, onMounted, h } from 'vue'
import createPeer from './components/createPeer.vue'
import { useStore } from 'vuex'
const $store = useStore()
const columns = [
    {
        title: '区域',
        dataIndex: 'quyu'
    },
    {
        title: '公司名称',
        dataIndex: 'companyname'
    },

    {
        title: '法人姓名',
        dataIndex: 'name'
    },

    {
        title: '电话',
        dataIndex: 'tel'
    },

    {
        title: '邮箱',
        dataIndex: 'mail'
    },

    {
        title: '注册时间',
        dataIndex: 'regtime'
    }
]
const templateFileTypeDic = new Map([
    [1, '普通模板'],
    [2, '图片模板']
])
const templateTypeDic = new Map([
    [1, '地址资料模板'],
    [2, '承诺书模板'],
    [3, '其他资料模板']
])

interface data {
    showCreate: boolean
    detailData: object
    loading: boolean
}
const state = reactive<data>({
    showCreate: false,
    detailData: {},
    loading: false
})
interface queryParam {
    companyname?: string
    quyu?: string
    tel?: string
    addr?: string
    template_type?: string
}

let param = ref<queryParam>({ name: '', quyu: '西安市' })
let queryParam = param.value
let dataSource = ref([])
const pagination = reactive<PaginationProps>({
    pageSize: 10,
    pageSizeOptions: ['10', '20', '30', '40'],
    current: 1,
    total: undefined,
    showSizeChanger: true,
    showQuickJumper: true,
    showTotal: (total) => `总数：${total}`
})
onMounted(() => {
    loadData()
})
const refreshTabel = () => {
    pagination.current = 1
    param.value = {}
    queryParam = param.value
    loadData()
}
const loadData = () => {
    state.loading = true
    // 获取到列表数据
    let requestParam = {
        url: '/admin/v1/txlList',
        method: 'post',
        data: Object.assign({ page: pagination.current, limit: pagination.pageSize }, queryParam)
    }
    baseService(requestParam)
        .then((res) => {
            state.loading = false
            pagination.total = res.data.total_records
            dataSource.value = res.data.list.map((item) => ({ ...item, isShowOptions: false }))
        })
        .catch((res) => {
            state.loading = false
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('获取列表失败')
            }
        })
}
const onChange = (val) => {
    pagination.pageSize = val.pageSize
    pagination.current = val.current
    loadData()
}
// 添加客户
const handleAdd = () => {
    state.detailData = {}
    state.showCreate = true
}
// 编辑客户
const handleEdit = (record) => {
    state.showCreate = true
    state.detailData = { ...record }
}
const handleDelete = (record) => {
    let requestParam = {
        url: '/admin/v1/template/' + record.id,
        method: 'delete'
    }
    baseService(requestParam)
        .then((res: any) => {
            message.success(res.msg)
            loadData()
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('操作失败')
            }
        })
}
//拨号
const onUsbphoneClick = (record, phone) => {
    $store.dispatch('usbphone/AddPhoneModal', {
        phone: phone,
        customer_id: null,
        full_name: record.name + '-' + record.companyname
    })
}
</script>

<style lang="less" scoped></style>
